<template>
	<div class="box01">
		<v-crumbs :crumbsType='12'></v-crumbs>
		<div>
			<div class="form_wrapper">
				<div class="form_wrapper_left">
					<div class="form_wrapper_block" style="position: relative;">
						<div class="shade_wrapper"></div>
						<div class="form_wrapper_title">
							<p></p>
							<p>基本信息</p>
						</div>
						<div class="info_wrapper">
							<div class="info_wrapper_block">
								<div class="form_input_wrapper">
									<p class="form_input_label">应付结算单号:</p>
									<div class="form_input">
										<el-input v-enter-next-input placeholder="保存时自动生成" v-model="info.handle_no"></el-input>
									</div>
								</div>
							</div>
							<div class="info_wrapper_block">
								<div class="form_input_wrapper">
									<p class="form_input_label">报价人员:</p>
									<div class="form_input">
										<el-input v-enter-next-input placeholder="请填写报价人员" v-model="info.bidder"></el-input>
									</div>
								</div>
							</div>
							<div class="info_wrapper_block">
								<div class="form_input_wrapper">
									<p class="form_input_label">报价有效期:</p>
									<div class="form_input">
										<el-date-picker v-enter-next-input type="date" placeholder="选择日期" v-model="info.validity">
										</el-date-picker>
									</div>
								</div>
							</div>
							<div class="info_wrapper_block">
								<div class="form_input_wrapper">
									<p class="form_input_label">服务类型:</p>
									<div class="form_input">
										<el-select v-enter-next-input placeholder="" v-model="info.service_type_id_name"></el-select>
										<div class="icon flex04">
											<img src="../../assets/01.png" />
										</div>
									</div>
								</div>
							</div>
							<div class="info_wrapper_block">
								<div class="form_input_wrapper">
									<p class="form_input_label">销售人员:</p>
									<div class="form_input">
										<el-input v-enter-next-input placeholder="" v-model="info.sales_person"></el-input>
									</div>
								</div>
							</div>
							<div class="form_choose_wrapper">
								<p class="form_input_label">服务范围:</p>
								<div class="form_choose_content" style="flex-wrap: wrap;">
									<div class="form_choose_block"
										:class="{'active': item.id == info.services_scope_id}"
										v-for="(item, index) in services_scope_list">
										<i></i>
										<p>{{item.name}}</p>
									</div>
								</div>
							</div>
							<div class="form_choose_wrapper">
								<p class="form_input_label">运输方式:</p>
								<div class="form_choose_content" style="flex-wrap: wrap;">
									<div class="form_choose_block" :class="{'active': item.id == info.transport_id}"
										v-for="(item, index) in transport_list">
										<i></i>
										<p>{{item.name}}</p>
									</div>
								</div>
							</div>
							<div class="form_choose_wrapper">
								<p class="form_input_label">运输流向:</p>
								<div class="form_choose_content" style="flex-wrap: wrap;">
									<div class="form_choose_block"
										:class="{'active': item.id == info.transportation_id}"
										v-for="(item, index) in transportation_list">
										<i></i>
										<p>{{item.name}}</p>
									</div>
								</div>
							</div>
							<div class="info_wrapper_block">
								<div class="form_input_wrapper">
									<p class="form_input_label">航司/船司:</p>
									<div class="form_input">
										<el-input v-enter-next-input placeholder="请填写航司/船司" v-model="info.shipping_company_name">
										</el-input>
										<div class="icon flex04">
											<img src="../../assets/01.png" />
										</div>
									</div>
								</div>
							</div>
							<div class="info_wrapper_block">
								<div class="form_input_wrapper">
									<p class="form_input_label">线路:</p>
									<div class="form_input">
										<el-select v-enter-next-input placeholder="选择线路" v-model="info.circuit_id_name"></el-select>
										<div class="icon flex04">
											<img src="../../assets/01.png" />
										</div>
									</div>
								</div>
							</div>
							<div class="info_wrapper_block">
								<div class="form_input_wrapper">
									<p class="form_input_label">运单编号:</p>
									<div class="form_input w_510">
										<el-input v-enter-next-input v-model="info.waybill_no" placeholder="请填写运单编号"></el-input>
									</div>
								</div>
							</div>
							<div class="info_wrapper_block">
								<div class="form_input_wrapper">
									<p class="form_input_label w_118">起运地/起运港:</p>
									<div class="form_input w_480">
										<el-select v-enter-next-input placeholder="选择起运地/起运港" v-model="info.shipment_id_name"></el-select>
										<div class="icon flex04">
											<img src="../../assets/01.png" />
										</div>
									</div>
								</div>
							</div>
							<div class="info_wrapper_block">
								<div class="form_input_wrapper">
									<p class="form_input_label w_118">目的地/目的港:</p>
									<div class="form_input w_480">
										<el-select v-enter-next-input placeholder="选择目的地/目的港" v-model="info.destination_id_name">
										</el-select>
										<div class="icon flex04">
											<img src="../../assets/01.png" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="form_wrapper_block" style="position: relative;">
						<div class="shade_wrapper"></div>
						<div class="form_wrapper_title">
							<p></p>
							<p>货物信息</p>
						</div>
						<div class="form_table_wrapper">
							<div>
								<div class="form_table_list" v-for="(item, index) in info.cargo" :key="index">
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label">件数:</p>
											<div class="form_input">
												<el-input v-enter-next-input placeholder="请填写件数" v-model="item.cases"></el-input>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label">包装:</p>
											<div class="form_input">
												<!-- <v-select :list="pack_list" :index="index" :value_name="item.pack" @result="get_pak"></v-select> -->
												<el-input v-enter-next-input placeholder="请填写包装" v-model="item.pack"></el-input>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label">毛重:</p>
											<div class="form_input">
												<el-input v-enter-next-input placeholder="请填写毛重" v-model="item.rough_weight"></el-input>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label">计重:</p>
											<div class="form_input" style="display: flex;align-items: center;">
												<el-input v-enter-next-input placeholder="自动算出" v-model="item.weight"></el-input>
												<p class="form_input_unit">KG</p>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label">长:</p>
											<div class="form_input">
												<el-input v-enter-next-input placeholder="请填写长度" v-model="item.long"></el-input>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label">宽:</p>
											<div class="form_input">
												<el-input v-enter-next-input placeholder="请填写宽度" v-model="item.broad"></el-input>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label">高:</p>
											<div class="form_input">
												<el-input v-enter-next-input placeholder="请填写高度" v-model="item.tall"></el-input>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label">体积:</p>
											<div class="form_input" style="display: flex;align-items: center;">
												<el-input v-enter-next-input placeholder="自动算出" v-model="item.bulk"></el-input>
												<p class="form_input_unit">CBM</p>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label">中文品名:</p>
											<div class="form_input">
												<el-input v-enter-next-input placeholder="请填写中文品名" v-model="item.chinese_name"></el-input>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label">英文品名:</p>
											<div class="form_input w_476">
												<el-input v-enter-next-input placeholder="请填写英文品名" v-model="item.english_name"></el-input>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label">HS编码:</p>
											<div class="form_input">
												<el-input v-enter-next-input placeholder="请填写HS编码" v-model="item.hs_code_name"></el-input>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label">货值:</p>
											<div class="form_input">
												<el-input v-enter-next-input placeholder="请填写货值" v-model="item.low_value"></el-input>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label">币制:</p>
											<div class="form_input">
												<el-input v-enter-next-input placeholder="请填写币制" v-model="item.currency_system_name">
												</el-input>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label">船名/航次:</p>
											<div class="form_input">
												<el-input v-enter-next-input placeholder="请填写船名/航次" v-model="item.flight_name"></el-input>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label">起运时间:</p>
											<div class="form_input">
												<el-date-picker v-enter-next-input type="date" placeholder="选择日期"
													v-model="item.shipment_date"></el-date-picker>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="form_wrapper_block" style="position: relative;">
						<div class="shade_wrapper"></div>
						<div class="form_wrapper_title">
							<p></p>
							<p>成本费用信息</p>
						</div>
						<div class="form_table_wrapper">
							<!-- <div class="form_table_add">
								<div class="form_table_add_block">
									<img src="../../assets/04@2x.png" @click="get_add_feiyong" />
									<p>新增费用</p>
								</div>
							</div> -->
							<div>
								<div class="form_th_wrapper">
									<div class="form_th_list">
										<div class="form_th_list_block">序号</div>
										<div class="form_th_list_block active">费用名称</div>
										<div class="form_th_list_block">数量</div>
										<div class="form_th_list_block">单价</div>
										<div class="form_th_list_block">金额</div>
										<div class="form_th_list_block">币制</div>
										<div class="form_th_list_block active">备注</div>
										<div class="form_th_list_block active">操作</div>
									</div>
									<div class="form_th_list"
										v-for="(item, index) in info.receivable_info.receivable_data" :key="index">
										<div class="form_th_list_block">{{index + 1}}</div>
										<div class="form_th_list_block active" v-if="!item.is_save">
											<el-select v-enter-next-input v-model="item.name_id_name" filterable placeholder="请选择"
												@change="get_change(1, $event, index)">
												<el-option v-for="item in feiyong_list" :key="item.id"
													:label="item.name" :value="item"></el-option>
											</el-select>
										</div>
										<div class="form_th_list_block active" v-else>{{item.name_id_name}}</div>
										<div class="form_th_list_block" v-if="!item.is_save">
											<el-input v-enter-next-input placeholder="请输入数量" v-model="item.number"></el-input>
										</div>
										<div class="form_th_list_block" v-else>{{item.number}}</div>
										<div class="form_th_list_block" v-if="!item.is_save">
											<el-input v-enter-next-input placeholder="请输入单价" v-model="item.money"></el-input>
										</div>
										<div class="form_th_list_block" v-else>{{item.money}}</div>
										<div class="form_th_list_block" v-if="!item.is_save">
											<el-input v-enter-next-input placeholder="请输入金额" v-model="item.price"></el-input>
										</div>
										<div class="form_th_list_block" v-else>{{item.price}}</div>
										<div class="form_th_list_block" v-if="!item.is_save">
											<el-select v-model="item.currency_system_name" filterable placeholder="请选择"
												@change="get_change(2, $event, index)">
												<el-option v-for="item in bizhi_list" :key="item.id" :label="item.name"
													:value="item"></el-option>
											</el-select>
										</div>
										<div class="form_th_list_block" v-else>{{item.currency_system_name}}</div>
										<div class="form_th_list_block active" v-if="!item.is_save">
											<el-input v-enter-next-input placeholder="请输入备注" v-model="item.remark"></el-input>
										</div>
										<div class="form_th_list_block active" v-else>{{item.remark?item.remark: '-'}}
										</div>
										<div class="form_th_list_block operat active">
											<div class="c_5bbef0 pointer_" @click="get_resource_btn(item)">
												{{item.is_save?'编辑': '保存'}}</div>
											<div class="c_ff6f6f pointer_ m_l21" @click="get_resource_del(index, item)">
												删除</div>
										</div>
									</div>
								</div>
							</div>
							<div class="form_total">
								<div style="flex: 1;display: flex;flex-wrap: wrap;">
									<div class="form_total" v-if="item.rate_id != 7" v-for="(item, index) in hv"
										:key="index">
										<p>{{item.rate_name}}*汇率：</p>
										<div class="form_total_input">
											<el-input v-enter-next-input placeholder="" v-model="item.input_id"></el-input>
										</div>
									</div>
								</div>
								<div>
									<div class="form_total">
										<p>合计：</p>
										<div class="form_total_input">
											<el-input v-enter-next-input placeholder="" v-model="info.cost_total_price"></el-input>
										</div>
										<p>RMB</p>
									</div>
									<!-- <p class="c_ff6f6f hj_btn" style="margin-left: 67px;cursor: pointer;" @click="get_heji">点击获取合计数据</p> -->
								</div>
							</div>
							<!-- <div class="form_total">
								<p>合计：</p>
								<div class="form_total_input">
									<el-input placeholder="" v-model="info.cost_total_price" readonly @input="get_total"></el-input>
								</div>
								<p>RMB</p>
							</div> -->
						</div>
					</div>
				</div>
				<div class="form_wrapper_right form_wrapper_block" style="position: relative;">
					<div class="shade_wrapper" v-if="type_"></div>
					<div class="form_choose_wrapper">
						<p class="form_input_label">对账情况：</p>
						<div class="form_choose_content">
							<div class="form_choose_block"
								:class="{'active': info.receivable_info.reconciliation_id == 1}"
								style="margin-right: 52px;">
								<i @click="info.receivable_info.reconciliation_id = 1"></i>
								<p>已确认</p>
							</div>
							<div class="form_choose_block"
								:class="{'active': info.receivable_info.reconciliation_id === 0}">
								<i @click="info.receivable_info.reconciliation_id = 0"></i>
								<p>未确认</p>
							</div>
						</div>
					</div>
					<div class="form_choose_wrapper">
						<p class="form_input_label">开票情况：</p>
						<div class="form_choose_content">
							<div class="form_choose_block" :class="{'active': info.receivable_info.make_invoice == 1}"
								style="margin-right: 52px;">
								<i @click="info.receivable_info.make_invoice = 1"></i>
								<p>已开票</p>
							</div>
							<div class="form_choose_block" :class="{'active': info.receivable_info.make_invoice === 0}">
								<i @click="info.receivable_info.make_invoice = 0"></i>
								<p>未开票</p>
							</div>
						</div>
					</div>
					<div class="">
						<div class="flex01 m_b27">
							<p class="form_input_label">结算情况：</p>
							<div>
								<div class="flex01 form_right_add">
									<img src="../../assets/04@2x.png" @click="get_add_jiesuan" />
									<p>新增</p>
								</div>
							</div>
						</div>
						<div class="m_tb15" v-for="(item, index) in info.receivable_info.settlement_text" :key="index">
							<div class="flex01">
								<div class="m_r15" style="flex: 1;">
									<el-date-picker v-enter-next-input type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
										v-model="item.settlement_date" @change="get_change_settle_date">
									</el-date-picker>
								</div>
								<div class="m_r10" style="flex: 1;">
									<el-input v-enter-next-input placeholder="" v-model="item.price" @input="get_settlement_input">
									</el-input>
								</div>
								<p class="font_14">RMB</p>
							</div>
						</div>
					</div>
					<div class="form_input_wrapper">
						<p class="form_input_label">应付金额：</p>
						<div class="form_input w_84">
							<el-input v-enter-next-input placeholder="" v-model="info.receivable_info.receivable" readonly></el-input>
						</div>
						<p class="font_14 m_l10">RMB</p>
					</div>
					<div class="form_input_wrapper">
						<p class="form_input_label">已付金额：</p>
						<div class="form_input w_84">
							<el-input v-enter-next-input placeholder="" v-model="info.receivable_info.received" readonly></el-input>
						</div>
						<p class="font_14 m_l10">RMB</p>
					</div>
					<div class="form_input_wrapper">
						<p class="form_input_label">待付金额：</p>
						<div class="form_input w_84">
							<el-input v-enter-next-input placeholder="" v-model="info.receivable_info.collected" readonly></el-input>
						</div>
						<p class="font_14 m_l10">RMB</p>
					</div>
					<div class="form_input_wrapper">
						<p class="form_input_label">供应商名称：</p>
						<div class="form_input">
							<v-select :icon_num="true" :list="kehu_list" :index="1" :value_name="kehu_name"
								@result="get_kehu_serch"></v-select>
						</div>
					</div>
					<div class="form_input_wrapper">
						<p class="form_input_label">联系人：</p>
						<div class="form_input">
							<v-select :icon_num="true" :list="lxr_list" :index="2" :value_name="lxr_name"
								@result="get_kehu_serch"></v-select>
						</div>
					</div>
					<div class="form_input_wrapper">
						<p class="form_input_label">联系电话：</p>
						<div class="form_input">
							<el-input v-enter-next-input placeholder="请填写联系电话" v-model="info.receivable_info.mobile"></el-input>
						</div>
					</div>
					<div class="form_input_wrapper">
						<p class="form_input_label">联系邮箱：</p>
						<div class="form_input">
							<el-input v-enter-next-input placeholder="请填写联系邮箱" v-model="info.receivable_info.email"></el-input>
						</div>
					</div>
					<div class="form_input_wrapper">
						<p class="form_input_label">结算账期:</p>
						<div class="form_input">
							<el-input v-enter-next-input v-model="zhangqi_name" placeholder="请填写联系邮箱" readonly=""></el-input>
							<!-- <v-select :icon_num="true" :list="zhangqi_list" :index="3" :value_name="zhangqi_name" @result="get_kehu_serch"></v-select> -->
						</div>
					</div>
					<div class="form_input_wrapper">
						<p class="form_input_label">结算方式:</p>
						<div class="form_input">
							<v-select v-enter-next-input :icon_num="true" :list="fangshi_list" :index="4" :value_name="fangshi_name"
								@result="get_kehu_serch"></v-select>
						</div>
					</div>
					<div style="border: 1px solid #486AA5;margin: 29px 0 0;"></div>
					<div class="form_wrapper_info">
						<p class="form_wrapper_info_title">备注:</p>
						<div>
							<el-input v-enter-next-input type="textarea" placeholder="请填写备注" v-model="info.receivable_info.remark">
							</el-input>
						</div>
					</div>
				</div>
			</div>
			<div class="form_wrapper" v-if="!type_">
				<div class="form_wrapper_block" style="width: 100%;">
					<div class="form_wrapper_btn_wrapper">
						<div class="btn01" @click="get_save_info">保存</div>
						<div class="btn01" @click="$publicFun.get_link('/settle/pay/pdf?id=' + id + '&ids=' + ids, {})">
							预览</div>
						<div class="btn01" @click="$publicFun.get_link('/settle/pay/pdf?id=' + id + '&ids=' + ids, {})">
							导出</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import crumbs from '../../components/crumbs/index.vue'; // 面包屑
	import select from '../../components/select/index05.vue'; // 可输入搜索框

	import {
		DegressionShow,
		DegressionEdit,
		serviceType,
		services,
		tspMode,
		transport,
		costName,
		currency,
		companyList,
		getAllLinkman,
		payDays,
		payType,
		DegressionDelById,
		packing,
		companyDetail
	} from '@/api/index';

	export default {
		components: {
			'v-crumbs': crumbs,
			'v-select': select
		},
		data() {
			return {
				id: '',
				ids: '',
				pack_list: [],
				type_: false,
				lxr_id: '',
				lxr_name: '',
				lxr_list: [],
				kehu_id: '',
				kehu_name: '',
				kehu_list: [],
				feiyong_all: 0,
				bizhi_list: [],
				feiyong_list: [],
				zhangqi_list: [],
				zhangqi_id: '',
				zhangqi_name: '',
				fangshi_list: [],
				fangshi_id: '',
				fangshi_name: '',
				transport_list: [],
				services_scope_list: [],
				transportation_list: [],
				info: {
					service_type: {},
					ship_company: {},
					circuit: {},
					shipment: {},
					destination: {},
					receivable_info: {},
					settlement_text: [],
				},
				hv: [],
			}
		},
		created() {
			this.id = this.$route.query.id;
			this.ids = this.$route.query.ids;
			if (this.$route.query.type) {
				this.type_ = true
			}

			this.get_detail();
			this.getServicesList();
			this.getTspModeList();
			this.getTransportList();
			this.getCostNameList();
			this.getCurrencyList();
			this.getCompanyList();
			this.getPackingList();
		},
		watch: {
			'info.receivable': {
				deep: true,
				handler(val) {
					let list_ = val;

					list_.forEach((n, k) => {
						if (n.money && n.number) {
							n.price = (Number(n.money) * Number(n.number)).toFixed(2);
						} else {
							n.price = '';
						}
					})
				}
			}
		},
		methods: {
			// 包装列表
			getPackingList() {
				packing({
					page: 1,
					limit: 100000
				}).then(res => {
					let list_ = res.data.data;

					list_.forEach((n, k) => {
						this.pack_list.push({
							label: n.name,
							value: n.id
						})
					})
				})
			},
			get_pak(e) {
				this.huowu_list[e.index].pack = e.label;
			},
			// 详情
			get_detail() {
				DegressionShow({
					order_id: this.id,
					id: this.ids
				}).then(res => {
					if (res.data.receivable_info.receivable_data.length !== 0) {
						res.data.receivable.forEach((n, k) => {
							n.is_save = true

							this.feiyong_all += parseFloat(n.price)
						})
					}

					if (res.data.receivable_info.company_id) {
						// 客户名称
						this.kehu_id = res.data.receivable_info.company_id;
						this.kehu_name = res.data.receivable_info.company_id_name;
					}

					if (res.data.receivable_info.linkman_id) {
						// 联系人
						this.lxr_id = res.data.receivable_info.linkman_id;
						this.lxr_name = res.data.receivable_info.linkman_id_name;
					}

					if (res.data.receivable_info.payment_days) {
						// 结算账期
						this.zhangqi_id = res.data.receivable_info.payment_days;
						this.zhangqi_name = res.data.receivable_info.payment_days_name;
					}

					if (res.data.receivable_info.pay_type) {
						// 结算方式
						this.fangshi_id = res.data.receivable_info.pay_type;
						this.fangshi_name = res.data.receivable_info.pay_type_name;
					}

					if (!res.data.receivable_info.settlement_text) {
						res.data.receivable_info.settlement_text = [{
							settlement_date: '',
							price: ''
						}]
					}

					this.hv = res.data.receivable_info.rate;

					res.data.cost_total_price = res.data.receivable_info.total_price;
					this.info = res.data;
					this.get_detail_();
				})
			},
			// 服务范围
			getServicesList() {
				services({
					page: 1,
					limit: 100000
				}).then(res => {
					this.services_scope_list = res.data.data;
				})
			},
			// 运输方式
			getTspModeList() {
				tspMode({
					page: 1,
					limit: 100000
				}).then(res => {
					this.transport_list = res.data.data;
				})
			},
			// 运输流向
			getTransportList() {
				transport({
					page: 1,
					limit: 100000
				}).then(res => {
					this.transportation_list = res.data.data;
				})
			},
			// 费用名称
			getCostNameList() {
				costName({
					page: 1,
					limit: 100000
				}).then(res => {
					res.data.data.forEach((n, k) => {
						n.name = n.name + '/' + n.english_name
					})

					this.feiyong_list = res.data.data;
				})
			},
			// 币制
			getCurrencyList() {
				currency({
					page: 1,
					limit: 100000
				}).then(res => {
					this.bizhi_list = res.data.data;
				})
			},
			// 供应商名称
			getCompanyList() {
				companyList({
					page: 1,
					limit: 100000,
					partner_type: 1
				}).then(res => {
					let list_ = res.data.data;

					list_.forEach((n, k) => {
						this.kehu_list.push({
							label: n.company_name,
							value: n.id
						})
					})
				})
			},
			// 根据企业id 获取联系人
			get_linkman_list() {
				getAllLinkman({
					company_id: this.kehu_id
				}).then(res => {
					let list_ = res.data;
					this.lxr_list = [];

					list_.forEach((n, k) => {
						this.lxr_list.push({
							label: n.username,
							value: n.id
						})
					})
				})
			},
			// 结算账期
			getPayDays() {
				payDays({
					page: 1,
					limit: 100000
				}).then(res => {
					let name_ = '';
					let list_ = res.data.data;

					list_.forEach((n, k) => {
						if (n.id == this.zhangqi_id) {
							name_ = n.name
						}

						this.zhangqi_list.push({
							label: n.name,
							value: n.id
						})
					})

					this.zhangqi_name = name_;
				})
			},
			// 结算方式
			getPayTypeList(ids) {
				payType({
					page: 1,
					limit: 100000
				}).then(res => {
					this.fangshi_list = [];
					let list_ = res.data.data;
					let ids_array = ids.split(',');

					list_.forEach((n, k) => {
						ids_array.forEach((n_, k_) => {
							if (n.id == n_) {
								n.is_show = true;
							}
						})
					})

					list_.forEach((n, k) => {
						if (n.is_show) {
							this.fangshi_list.push({
								label: n.name,
								value: n.id
							})
						}
					})
				})
			},
			// 根据客户名称查结算账期 结算方式
			// 详情数据
			get_detail_() {
				companyDetail({
					id: this.kehu_id
				}).then(res => {
					this.zhangqi_id = res.data.finance.payment_days;

					this.getPayDays();
					this.getPayTypeList(res.data.finance.pay_type);
				})
			},
			get_kehu_serch(e) {
				if (e.index === 1) {
					// 客户名称
					this.kehu_id = e.value;
					this.kehu_name = e.label;
					this.get_linkman_list();
					this.get_detail_();
					this.lxr_id = '';
					this.lxr_name = '';
					this.fangshi_id = '';
					this.fangshi_name = '';
				}

				if (e.index === 2) {
					// 联系人
					this.lxr_id = e.value;
					this.lxr_name = e.label;
				}

				if (e.index === 3) {
					// 结算账期
					this.zhangqi_id = e.value;
					this.zhangqi_name = e.label;
				}

				if (e.index === 4) {
					this.fangshi_id = e.value;
					this.fangshi_name = e.label;
				}
			},
			// 新增费用
			get_add_feiyong() {
				this.info.receivable.push({
					is_save: false,
					name_id: '', // 费用名称
					name_id_name: '',
					number: '', // 数量
					money: '', // 单价
					currency_system: '', // 币制
					currency_system_name: '',
					remark: '', // 备注
					price: '' // 金额
				})
			},
			get_change(type, e, index) {
				// 费用名称
				if (type === 1) {
					this.info.receivable[index].name_id = e.id;
					this.info.receivable[index].name_id_name = e.name;
				}

				// 币制
				if (type === 2) {
					this.info.receivable[index].currency_system = e.id;
					this.info.receivable[index].currency_system_name = e.name;
				}
			},
			// 保存/编辑
			get_resource_btn(item) {
				for (let i in item) {
					if (!item[i] && i !== 'is_save' && i !== 'createtime_text' && i !== 'cost_name' && i !==
						'createtime' && i !==
						'updatetime' && i !== 'is_delete' && i !== 'creator_id') return this.$message('请将内容填写完整');
				}

				item.is_save = !item.is_save;

				if (item.is_save) {
					// 保存 计算金额
					this.feiyong_all = 0;

					this.get_all_price();
				}

				this.$forceUpdate();
			},
			// 删除
			get_resource_del(index, item) {
				if (this.info.receivable.length === 1) return this.$message.error('至少保留一条数据');

				this.$confirm('确定删除吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					if (item.id) {
						DegressionDelById({
							id: item.id
						}).then(res => {
							this.info.receivable.splice(index, 1);
							this.get_all_price();
						})
					} else {
						this.info.receivable.splice(index, 1);
						this.get_all_price();
					}
				})
			},
			get_all_price() {
				if (this.info.receivable.length !== 0) {
					this.feiyong_all = 0;

					this.info.receivable.forEach((n, k) => {
						if (n.is_save) {
							this.feiyong_all += parseFloat(n.price)
						}
					})
				}
			},
			// 新增结算
			get_add_jiesuan() {
				this.info.receivable_info.settlement_text.push({
					settlement_date: '', // 日期
					price: '' // 金额
				})
			},
			// 保存
			get_save_info() {
				let settlement_text_list = []; // 结算情况
				let order_cost_list = this.info.receivable_info.receivable_data; // 费用信息

				if (this.info.receivable_info.settlement_text.length !== 0) {
					this.info.receivable_info.settlement_text.forEach((n, k) => {
						if (n.settlement_date && n.price) {
							settlement_text_list.push(n)
						}
					})
				}

				let submit_info = {
					id: this.info.receivable_info.id,
					order_id: this.info.id,
					reconciliation_id: this.info.receivable_info.reconciliation_id,
					make_invoice: this.info.receivable_info.make_invoice,
					settlement: settlement_text_list,
					receivable: this.info.receivable_info.receivable,
					received: this.info.receivable_info.received,
					collected: this.info.receivable_info.collected,
					company_id: this.kehu_id,
					company_id_name: this.kehu_name,
					linkman_id: this.lxr_id,
					linkman_id_name: this.lxr_name,
					mobile: this.info.receivable_info.mobile,
					email: this.info.receivable_info.email,
					payment_days: this.zhangqi_id,
					payment_days_name: this.zhangqi_name,
					pay_type: this.fangshi_id,
					pay_type_name: this.fangshi_name,
					cost: order_cost_list,
					cost_total_price: this.info.cost_total_price, // 成本总计
					remark: this.info.receivable_info.remark
				}

				// 验证
				for (let i in submit_info) {
					if (i !== 'cost' && i !== 'settlement' && i !== 'collected' && i !== 'reconciliation_id' && i !==
						'make_invoice' &&
						!submit_info[i] && i !== 'received' && i !== 'email' && i !== 'remark') return this.$message(
						'请将内容填写完整');
				}

				// if (settlement_text_list.length === 0) return this.$message('请填写结算情况');
				if (order_cost_list.length === 0) return this.$message('请填写费用信息');

				if (submit_info.collected == 0) {
					this.$alert('代付款项已为零，确认之后订单将会转入已完成订单，不可在编辑。也不可再上传凭证。', '温馨提示', {
						confirmButtonText: '确定',
						callback: action => {
							if (action == 'confirm') {
								this.get_submit(submit_info);
							}
						}
					});
				} else {
					this.get_submit(submit_info);
				}
			},
			get_submit(e) {
				DegressionEdit(e).then(res => {
					this.$message.success('编辑成功！');
					this.$publicFun.get_link('/settle/pay/list', {});
				})
			},
			// 价格计算
			// 输入的总计
			get_total(e) {
				this.info.receivable_info.receivable = e;

				this.info.receivable_info.collected = parseFloat(this.info.receivable_info.receivable) - parseFloat(this
					.info.receivable_info
					.received); // 待收金额
			},
			// 选择结算日期
			get_change_settle_date() {
				this.get_p_jisuan()
			},
			get_settlement_input() {
				this.get_p_jisuan()
			},
			get_p_jisuan() {
				let yishou_ = 0;
				let settlement_text_list = []; // 结算情况

				if (this.info.receivable_info.settlement_text.length !== 0) {
					this.info.receivable_info.settlement_text.forEach((n, k) => {
						if (n.settlement_date && n.price) {
							settlement_text_list.push(n)
						}
					})
				}

				if (settlement_text_list.length !== 0) {
					settlement_text_list.forEach((n, k) => {
						yishou_ += parseFloat(n.price)
					})
				}

				this.info.receivable_info.received = yishou_;

				this.info.receivable_info.collected = parseFloat(this.info.receivable_info.receivable) - parseFloat(this
					.info.receivable_info
					.received); // 待收金额
			}
		}
	}
</script>

<style lang="less" scoped>
	.info_wrapper {
		padding: 12px 9px;
	}

	/deep/ input::-webkit-input-placeholder,
	/deep/ textarea::-webkit-input-placeholder {
		color: #5B8EF0;
	}

	/deep/ input::-moz-placeholder,
	/deep/ textarea::-webkit-input-placeholder {
		color: #5B8EF0;
	}

	/deep/ input:-moz-placeholder,
	/deep/ textarea::-webkit-input-placeholder {
		color: #5B8EF0;
	}

	/deep/ input:-ms-input-placeholder,
	/deep/ textarea::-webkit-input-placeholder {
		color: #5B8EF0;
	}

	.el-select-dropdown__item.selected {
		color: #606266;
		font-weight: 500;
	}
</style>
